// Build cost pricing logic

export const calculateBuildCost = (formData) => {
  // Base costs per square meter by project type
  const baseCostsPerSqM = {
    'extension': {
      'rear': 2200,
      'side': 2100,
      'side-infill': 2000,
      'wraparound': 2300,
      'side-and-rear': 2250,
      'two-storey': 2400
    },
    'loft': {
      'dormer': 1800,
      'hip-to-gable-main': 1900,
      'hip-to-gable-no': 1700,
      'l-shaped': 1950,
      'mansard': 2100,
      'velux': 1500,
      'outrigger': 1850
    },
    'first-floor': {
      'side-and-rear': 2300,
      'rear': 2200,
      'rear-over-outrigger': 2250,
      'rear-over-ground': 2300,
      'side': 2100
    },
    'basement': {
      'full': 3500,
      'partial': 3300,
      'extension': 3400
    },
    'other': {
      'garage-conversion': 1400,
      'garden-annex': 2000,
      'two-storey-rear': 2500,
      'two-storey-side': 2400
    },
    'new-build': 2600,
    'renovation': 1800
  };

  // Default square meters by project type
  const defaultSqM = {
    'extension': { 'rear': 20, 'side': 15, 'side-infill': 12, 'wraparound': 35, 'side-and-rear': 30, 'two-storey': 40 },
    'loft': { 'dormer': 25, 'hip-to-gable-main': 30, 'hip-to-gable-no': 20, 'l-shaped': 28, 'mansard': 35, 'velux': 18, 'outrigger': 24 },
    'first-floor': { 'side-and-rear': 35, 'rear': 25, 'rear-over-outrigger': 28, 'rear-over-ground': 30, 'side': 20 },
    'basement': { 'full': 60, 'partial': 35, 'extension': 45 },
    'other': { 'garage-conversion': 25, 'garden-annex': 30, 'two-storey-rear': 45, 'two-storey-side': 40 },
    'new-build': 120,
    'renovation': 80
  };

  let costPerSqM = 2200; // Default
  let estimatedSqM = 25; // Default

  // Get base cost per sqm
  if (formData.projectType && formData.specificType) {
    const projectCosts = baseCostsPerSqM[formData.projectType];
    if (projectCosts && projectCosts[formData.specificType]) {
      costPerSqM = projectCosts[formData.specificType];
    }
    
    const projectSqM = defaultSqM[formData.projectType];
    if (projectSqM && projectSqM[formData.specificType]) {
      estimatedSqM = projectSqM[formData.specificType];
    }
  } else if (formData.projectType) {
    const projectCosts = baseCostsPerSqM[formData.projectType];
    if (typeof projectCosts === 'object') {
      const values = Object.values(projectCosts);
      costPerSqM = Math.round(values.reduce((a, b) => a + b, 0) / values.length);
    }
  }

  // Use custom square meters if provided
  const squareMeters = formData.squareMeters || estimatedSqM;

  // Quality level multipliers
  const qualityMultipliers = {
    'standard': 1.0,
    'mid-range': 1.25,
    'high-end': 1.6,
    'luxury': 2.0
  };

  const qualityMultiplier = qualityMultipliers[formData.quality] || 1.0;

  // Calculate base build cost
  const baseBuildCost = squareMeters * costPerSqM * qualityMultiplier;

  // Additional costs
  const structuralEngineer = 1500;
  const buildingControl = 1200;
  const partyWall = formData.needsPartyWall ? 1800 : 0;
  const contingency = Math.round(baseBuildCost * 0.1); // 10% contingency

  const totalBuildCost = Math.round(baseBuildCost + structuralEngineer + buildingControl + partyWall + contingency);

  // Calculate ranges (±12% for build costs)
  const minBuildCost = Math.round(totalBuildCost * 0.88);
  const maxBuildCost = Math.round(totalBuildCost * 1.12);

  return {
    costPerSqM: Math.round(costPerSqM * qualityMultiplier),
    squareMeters,
    baseBuildCost: Math.round(baseBuildCost),
    structuralEngineer,
    buildingControl,
    partyWall,
    contingency,
    totalMin: minBuildCost,
    totalMax: maxBuildCost,
    totalAverage: totalBuildCost
  };
};
